module.exports = __webpack_public_path__ + "static/img/nav.50da011.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/nav.png
// module id = 8rlq
// module chunks = 1